__turbopack_context__.v({
  "disclaimer": "_3_zC-a_disclaimer",
  "disclaimer__header": "_3_zC-a_disclaimer__header",
  "disclaimer__icon": "_3_zC-a_disclaimer__icon",
  "disclaimer__img": "_3_zC-a_disclaimer__img",
  "disclaimer__left": "_3_zC-a_disclaimer__left",
  "disclaimer__right": "_3_zC-a_disclaimer__right",
  "ref": "_3_zC-a_ref",
  "ref-wrapper": "_3_zC-a_ref-wrapper",
});
